import React from 'react';
import { Box, Typography, Chip } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';

export const renderBooleanField = (label, value, classes) => {
	return (
		<Box className={classes.fieldValue} display="flex" alignItems="center">
			<Typography component="span" className={classes.fieldLabel}>
				{label}:
			</Typography>
			{value === true ? (
				<CheckCircleIcon style={{ color: '#4caf50', marginLeft: 4 }} fontSize="small" />
			) : value === false ? (
				<CancelIcon style={{ color: '#f44336', marginLeft: 4 }} fontSize="small" />
			) : (
				<Typography component="span" color="textSecondary">-</Typography>
			)}
		</Box>
	);
};

export const renderField = (label, value, classes) => {
	if (value === null || value === undefined) {
		return null;
	}

	// Check if this is a boolean field that should use icons
	if (typeof value === 'boolean') {
		return renderBooleanField(label, value, classes);
	}

	if (Array.isArray(value)) {
		return (
			<Box className={classes.fieldValue}>
				<Typography component="span" className={classes.fieldLabel}>
					{label}:
				</Typography>
				{value.length === 0 ? (
					<Typography component="span" color="textSecondary">
						(Empty array)
					</Typography>
				) : (
					<Chip
						label={`Array (${value.length} items)`}
						className={classes.chip}
						size="small"
					/>
				)}
			</Box>
		);
	}

	if (typeof value === 'object') {
		return (
			<Box className={classes.fieldValue}>
				<Typography component="span" className={classes.fieldLabel}>
					{label}:
				</Typography>
				<Chip
					label={`Object (${Object.keys(value).length} keys)`}
					className={classes.chip}
					size="small"
				/>
			</Box>
		);
	}

	return (
		<Box className={classes.fieldValue}>
			<Typography component="span" className={classes.fieldLabel}>
				{label}:
			</Typography>
			<Typography component="span">{String(value)}</Typography>
		</Box>
	);
};

export const renderSelectedDataElement = (dataElementArray, classes) => {
	if (!Array.isArray(dataElementArray) || dataElementArray.length === 0) {
		return <Typography color="textSecondary">(Empty)</Typography>;
	}
	const values = dataElementArray
		.map((item) => item?.value)
		.filter((val) => val !== undefined && val !== null);

	return (
		<Box display="flex" flexWrap="wrap">
			{values.map((value, index) => (
				<Chip
					key={index}
					label={value}
					className={classes.chip}
					size="small"
					style={{ marginRight: 8, marginBottom: 8 }}
				/>
			))}
		</Box>
	);
};

export const renderListView = (listViewObj, classes, renderSelectedDataElement) => {
	if (!listViewObj || typeof listViewObj !== 'object') {
		return <Typography color="textSecondary">(No listView data)</Typography>;
	}

	const entries = Object.entries(listViewObj);
	if (entries.length === 0) {
		return <Typography color="textSecondary">(Empty)</Typography>;
	}

	return (
		<Box>
			{entries.map(([key, value], index) => {
				return (
					<Box key={key} mb={2}>
						<Typography variant="h6" style={{ fontSize: '1rem', fontWeight: 600, marginBottom: 8 }}>
							{key}
						</Typography>
						{Array.isArray(value) ? (
							value.length === 0 ? (
								<Typography color="textSecondary">(Empty array)</Typography>
							) : key === 'selectedDataElement' ? (
								renderSelectedDataElement(value, classes)
							) : (
								<Typography>
									{value
										.map((item) => {
											if (typeof item === 'object' && item !== null && item.value) {
												return item.value;
											}
											return String(item);
										})
										.filter((v) => v !== undefined && v !== null)
										.join(', ')}
								</Typography>
							)
						) : typeof value === 'object' && value !== null ? (
							renderListView(value, classes, renderSelectedDataElement)
						) : (
							<Typography>{String(value)}</Typography>
						)}
					</Box>
				);
			})}
		</Box>
	);
};

